
import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";

const NotFound = () => {
  const location = useLocation();
  const [expectedRoutes, setExpectedRoutes] = useState<string[]>([]);
  const [errorDetails, setErrorDetails] = useState<string>("");

  useEffect(() => {
    // Log the error for debugging
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );

    // Add diagnostics about the current environment
    const isSSR = typeof window === 'undefined';
    const protocol = window.location.protocol;
    const host = window.location.host;
    
    setErrorDetails(`
      Path: ${location.pathname}
      Protocol: ${protocol}
      Host: ${host}
      User Agent: ${navigator.userAgent}
      Timestamp: ${new Date().toISOString()}
    `);

    // Gather expected routes from our route configuration for diagnostic purposes
    const routes = [
      "/",
      "/calculators",
      "/converters",
      "/special",
      "/special/auto",
      "/special/tip",
      "/special/mortgage",
      "/special/loan",
      "/special/pregnancy",
      "/special/pregnancy-weight",
      "/special/pregnancy-conception",
      "/special/due-date",
      "/special/ovulation",
      "/special/conception",
      "/special/period",
      // Add more expected routes here for diagnostic purposes
    ];
    
    setExpectedRoutes(routes.filter(route => 
      route.toLowerCase().includes(location.pathname.toLowerCase())
    ));
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold mb-4 text-center">404</h1>
        <p className="text-xl text-gray-600 mb-6 text-center">
          Page not found
        </p>
        <p className="text-gray-600 mb-4">
          The page <code className="bg-gray-100 px-2 py-1 rounded">{location.pathname}</code> doesn't exist.
        </p>
        
        {expectedRoutes.length > 0 && (
          <div className="mt-4">
            <p className="text-sm text-gray-600 mb-2">Did you mean one of these?</p>
            <ul className="list-disc pl-5 space-y-1">
              {expectedRoutes.map((route, index) => (
                <li key={index}>
                  <Link 
                    to={route} 
                    className="text-blue-500 hover:text-blue-700 underline"
                  >
                    {route}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
        
        <div className="mt-6 text-center">
          <Link to="/" className="text-blue-500 hover:text-blue-700 underline">
            Return to Home
          </Link>
        </div>
        
        {/* For development/debugging purposes */}
        <details className="mt-6 text-xs text-gray-500">
          <summary className="cursor-pointer">Technical Details</summary>
          <pre className="mt-2 p-2 bg-gray-100 rounded overflow-x-auto">
            {errorDetails}
          </pre>
        </details>
      </div>
    </div>
  );
};

export default NotFound;
